import { MeetingParticipantDto } from "./api/MeetingParticipantDto";
import { MeetingParticipant } from "./InMeetingAppService";
import { msTeamsMeetingRolesEnum } from "../enum/msTeamsMeetingRolesEnum";
import { constants } from "../../shared/constants";

export class ParticipantDataFromResponse {
    constructor(private participantDataFromResponse: MeetingParticipantDto) {}

    mapRole = (roleName: string) => {
        switch (roleName) {
            case constants.roles.organizer:
                return msTeamsMeetingRolesEnum.organizer;
            case constants.roles.presenter:
                return msTeamsMeetingRolesEnum.presenter;
            default:
                return msTeamsMeetingRolesEnum.none;
        }
    };

    meetingParticipant(): MeetingParticipant {
        return {
            role: this.mapRole(this.participantDataFromResponse.call.meeting.role),
        };
    }
}
